import { Entity } from '@betgames/bg-state-manager';
import { GameId } from '@bg-shared/enums/GameId';
import { IPlayerWonModel } from './interfaces';

export class PlayerWonEntity extends Entity<IPlayerWonModel, GameId> {
    constructor() {
        super({
            key: 'PlayerWon',
            default: null,
        });
    }
}

export const playerWonEntity = new PlayerWonEntity();
